import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Overview from "./pages/Overview";
import Trend from "./pages/Trend";
import Comparison from "./pages/Comparison";
import Individuals from "./pages/Individuals";
import Data from "./pages/Data";
import Feedback from "./pages/Feedback";
import Joyride from 'react-joyride';


// function App() {
//     return (
//         <Router>
//             <Navbar />
//             <Routes>
//                 <Route path="/" element={<Overview />} />
//                 <Route path="/trend" element={<Trend />} />
//                 <Route path="/comparison" element={<Comparison />} />
//                 <Route path="/individuals" element={<Individuals />} />
//                 <Route path="/data" element={<Data />} />
//                 <Route path="/feedback" element={<Feedback />} />
//             </Routes>
//         </Router>
//     );
// }

const AppContent = () => {
    const location = useLocation();
    const [run, setRun] = useState(true);

    const steps = {
        "/": [
            { target: ".step-overview-1", content: "Welcome to iTOOLS! This dashboard provides interactive live report of your students." },
            { target: ".step-overview-2", content: "Use the navigation bar to explore different sections of the dashboard" },
            { target: ".step-overview-3", content: "Check this table to understand what socioemotional aspects are measured, along with examples of the survey questions they answered." },
        ],
        "/trend": [
            { target: ".step-trend-1", content: "This is a Trend page element." }
        ]
        // Add steps for other routes if needed
    };

    return (
        <>
            {/* <Joyride
                steps={steps[location.pathname] || []}
                run={run}
                continuous
                showSkipButton
                showProgress
                styles={{ options: { zIndex: 10000 } }}
            /> */}
            <Navbar />
            <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/trend" element={<Trend />} />
                <Route path="/comparison" element={<Comparison />} />
                <Route path="/individuals" element={<Individuals />} />
                <Route path="/data" element={<Data />} />
                <Route path="/feedback" element={<Feedback />} />
            </Routes>
        </>
    );
};

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;